module.exports = __webpack_public_path__ + "img/baqiaozheng.186ea0a1.png";